import GlobalStore from "@ipru-common/store/GlobalStore";
import { convertToDateTime, readQueryParams } from "../CommonFunctions";
import { OPTION_VALUES } from "@ipru-common/constants/InputValues";
import { LMS_CONSTANTS } from "@ipru-common/constants/SiteConstants";
import { mapDataToSuitabilityData } from "@ipru-common/components/CommonComponents/SuitabilityCalModal/SuitabilityMapper";
import { getAge } from "@ipru-common/libs/ValidationSchemas/CustomRules";
import { getWOPOption, yesNo } from "../SavingsAppForm/SavingAppFormsUtils";
import { calculateAnnualPremium } from "../SmartKidQuote/commonUtils";
import { getDefermentPeriod } from "../SavingsQuote/SavingsQuoteUtils";

const getPngNetCoreInput = () => {
  const {
    appFormData,
    quoteFormData,
    calculatorFormData,
    savingForm,
    existingCustomer,
    currentPageStep,
    navFundReleasedCode,
  } = GlobalStore.getSnapshot();
  const suitabilityData = mapDataToSuitabilityData(calculatorFormData, quoteFormData);
  const queryParams = readQueryParams();
  const { isWopSelected, wopOption } = getWOPOption(quoteFormData?.selectedRiders);
  const { personalDetails } = appFormData;
  const RiderOptionAdded =
    !!quoteFormData?.selectedRiders?.length > 0 ? OPTION_VALUES.TRUE_STRING : OPTION_VALUES.FALSE_STRING;
  const UID = queryParams.get("UID") || "480";
  const annualPremium = calculateAnnualPremium(quoteFormData?.invest, quoteFormData?.paymentFrequency);

  const holdData = quoteFormData?.calculatedData?.pngQuoteData;

  let pngInput = {
    age: calculatorFormData?.age,
    dob: convertToDateTime(calculatorFormData?.user_dob),
    gender: calculatorFormData?.gender,
    term: quoteFormData?.term,
    mobileno: calculatorFormData?.mobileno,
    emailid: calculatorFormData?.emailid,
    pincode: calculatorFormData?.pincode,
    premium: quoteFormData?.calculatedData?.pngQuoteData?.TotalFirstPremiumShow,
    occupation: calculatorFormData?.calc_occupation,
    nominee: personalDetails?.nominee_fullname,
    trai: calculatorFormData?.trai_flag,
    paymentoption: LMS_CONSTANTS[quoteFormData?.paymentOption],
    relation: suitabilityData?.relation,
    mode: suitabilityData?.mode,
    ppt: quoteFormData?.ppt,
    lifecover: quoteFormData?.lifeCover,
    productid: calculatorFormData?.productCode,
    invest_type: suitabilityData?.invest_type,
    outputobjhold_4: holdData?.PurchaseAnnuity6,
    outputobjhold_8: holdData?.PurchaseAnnuity10,
    uid: UID,
    annualincome: parseInt(calculatorFormData?.yr_income),
    step: `step${savingForm?.currentStep}`,
    adbr: suitabilityData?.adbr,
    payout: LMS_CONSTANTS[quoteFormData?.payoutType] ?? "LumpSum",
    existing_cust: calculatorFormData?.employeeId || existingCustomer ? OPTION_VALUES.Y_YES : OPTION_VALUES.N_NO,
    invest_strat: suitabilityData?.invest_strat,
    fundcat: "", //suitabilityData?.fundCat
    modalpremium: quoteFormData?.invest,
    staff: calculatorFormData?.staff === OPTION_VALUES.STAFF_N ? OPTION_VALUES.N_NO : OPTION_VALUES.Y_YES,
    name: personalDetails?.full_name,
    traiflag: yesNo(calculatorFormData?.trai_flag),
    appformdetails: "",
    communication: "",
    health: "",
    payoutdetails: "",
    proposerdetails: "",
    proposercommunication: "",
    sourceurl: window.location.origin + window.location.pathname,
    existingcustomer: yesNo(existingCustomer?.clientId),
    qdata_pasa: false,
    p_gender: calculatorFormData?.propGender,
    p_dob: calculatorFormData?.propAge,
    p_age: calculatorFormData?.propAge ? getAge(calculatorFormData?.propAge) : "",
    rideroptionadded: RiderOptionAdded,
    rider1: quoteFormData?.selectedRiders?.[0]?.sectionName,
    rider2: quoteFormData?.selectedRiders?.[1]?.sectionName,
    rider3: quoteFormData?.selectedRiders?.[2]?.sectionName,
    wop_selctedoption: wopOption,
    education: calculatorFormData?.calc_education,
    iswhatsappopted: yesNo(quoteFormData?.wth_option),
    health_la: "",
    health_pa: "",
    iswop: yesNo(isWopSelected),
    propdob: calculatorFormData?.propAge ?? "",
    propgender: calculatorFormData?.propGender,
    city: calculatorFormData?.city,
    suitcheckbox: suitabilityData?.skip_suitability_check,
    qdata: queryParams?.get("qdata") ?? "",
    brochure_selected: "",
    tollfree_selected: "",
    isandroid: new URL(window.location.href).searchParams.get("device") === "android",
    isios: new URL(window.location.href).searchParams.get("device") === "ios",
    appno: appFormData?.appNO,
    selectedfunds: "",
    productselection: "",
    kycwaveoff: "",
    suitabilitymatrix: "", // suitabilityMatrix,
    emailaddress: calculatorFormData?.emailid,
    pan_validation_status: "",
    ekycdetails: "",
    savingspercentage: suitabilityData?.pastPerformancePercent,
    payoutoption: LMS_CONSTANTS[quoteFormData?.payoutType],
    payoutterm: quoteFormData?.incomeFor || "",
    policyterm: quoteFormData?.term,
    ekyc_flag: appFormData?.Ekyc?.EKYC_flag,
    ckycflag: appFormData?.CkycJson?.CKYCflag,
    income_date: "",
    guaranteedcashbenefit: quoteFormData?.calculatedData?.giftProData?.guaranteedCashBenefitNumber,
    guaranteedcashbenefit2: quoteFormData?.calculatedData?.giftProData?.guaranteedCashBenefitNumber,
    guranteed_returns: quoteFormData?.calculatedData?.giftProData?.income,
    income_frequency: quoteFormData?.incomeForFrequency,
    specialdate: quoteFormData?.incomeDate ?? "",
    state: calculatorFormData?.state,
    total_amount: quoteFormData?.calculatedData?.giftProData?.overallReturns,
    // NOT IN SIGNATURE NET CORE , BUT NEEDED BEC OF COMMON IMPLEMENTATION
    currentpagestep: currentPageStep,
    isenglish: "TRUE",
    trai_flag: yesNo(calculatorFormData?.trai_flag),
    cage: "",
    cdob: "",
    child_gender: "",
    continueappform: "",
    la1_tobacco: calculatorFormData?.tobacco,
    returns: quoteFormData?.calculatedData?.giftProData?.overallReturns,
    annual_prem: annualPremium,
    defermentperiod: getDefermentPeriod(),
    incomemode: quoteFormData?.tenure,
    lifecovernew: quoteFormData?.lifeCover,
    newannualincome: parseInt(calculatorFormData?.yr_income),
    optformaturity: "No",
    optforrop: quoteFormData.wantMoneyback || "",
    pensionfrequency: quoteFormData.incomeForFrequency || "",
    productcode: calculatorFormData?.productCode,
    whatsapp_flag: yesNo(calculatorFormData?.trai_flag) ? "Y" : "N",
    quote_deathbenefits: "",
    swp: "",
    funds: "",
    timestamp: new Date().toISOString(),
    desiredlifecover: "",
    maxannualrange: "",
    isdefaultpastrequired: "",
    minannualrange: "",
    adby_selected: "",
    samultiple: "",
    pfp_pk_id: "",
    whole_life: "",
    critical_illness_benefit: "",
    countrycode: "",
    dobspouse: "",
    nrimoblieno: "",
    internationalmobileno: "",
    adbterm: "",
    accidental_death_benefit: "",
    nriarrivingdate: "",
    sumassured: "",
    premiumwithci: "",
    annual_income: parseInt(calculatorFormData?.yr_income),
    citerm: "",
    NFOopt: navFundReleasedCode ? String(quoteFormData?.nfoOpt || OPTION_VALUES.N_NO).toLowerCase() : undefined,
  };

  return pngInput;
};

export default getPngNetCoreInput;
